import React, { useState, useEffect } from "react"
import { useLocation } from "react-router-dom"
import { useMediaQuery } from "react-responsive"

import Loading from "../components/Loading"
import Navbar from "../components/navbar/Navbar"
import MobileNav from "../components/navbar/MobileNav"
import RecipeCarousel from "../components/randomRecipe/RecipeCarousel"
import WineCarousel from "../components/randomWine/WineCarousel"
import { useGuide } from "../contexts/GuideContext"
import Guide from "../components/Guide"
import { useUser } from "../contexts/UserContext"
import Service from "../services/Service"

function Home({ allowFavorite }) {
    const location = useLocation()
    const guide = useGuide()
    const user = useUser()
    const { showGuide, setShowGuide } = guide
    const isMobileDevice = useMediaQuery({ query: "(max-device-width: 650px)" })

    const [showRecipe, setShowRecipe] = useState(true)
    const [showWine, setShowWine] = useState(true)
    const [loading, setLoading] = useState(false)
    const [storedRecipes, setStoredRecipes] = useState([])
    const [storedWine, setStoredWine] = useState([])

    useEffect(() => {
        const getIsNeverFromLS = () => {
            const choice = JSON.parse(localStorage.getItem("isNever")) || { uid: "", isNever: false }
            user?.uid === choice?.uid ? setShowGuide( false ) : setShowGuide( true )
            isMobileDevice && setShowGuide( false )
        }
        getIsNeverFromLS()
    }, [setShowGuide, isMobileDevice, user?.uid])

    useEffect(() => {
        setLoading(true)
        
        const getDataFromFS = () => {
            setLoading(true)
            let recipes = []
            let wine = []
            Service.recipeRef.onSnapshot(snapShot => {
                snapShot.forEach(doc => {
                    recipes.push(doc.data())
                })
            })
            Service.wineRef.onSnapshot(snapShot => {
                snapShot.forEach(doc => {
                    wine.push(doc.data())
                })

                const recipeSet = [...new Set(recipes)]
                const wineSet = [...new Set(wine)]

                shuffleArray(recipeSet)
                const partRecipe = recipeSet.splice(0, 3)
                setStoredRecipes(partRecipe)

                shuffleArray(wineSet)
                const partWine = wineSet.splice(0, 3)
                setStoredWine(partWine)
                setLoading(false)
            })
        }

        Service.handleFetchAndStoreFS()

        getDataFromFS()
    }, [])

    useEffect(() => {
        // console.log("allRecipes", allRecipes)
        // console.log("allWine", allWine)
        const checkRoute = () => {
            if (location.pathname.includes("/recipe")) {
                setShowWine(false)
            } else if (location.pathname.includes("/wine")) {
                setShowRecipe(false)
            } else {
                setShowRecipe(true)
                setShowWine(true)
            }
        }
        checkRoute()
    }, [location.pathname])

    const shuffleArray = array => {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1))
            const temp = array[i]
            array[i] = array[j]
            array[j] = temp
        }
    }

    if (loading) return <Loading />

    return (
        <>
            {isMobileDevice
                ? <MobileNav allowFavorite={allowFavorite} />
                : <Navbar allowFavorite={allowFavorite} />
            }
            <section id="homePage">
                {storedRecipes
                    && <RecipeCarousel
                        allRecipes={storedRecipes}
                        showRecipe={showRecipe}
                        setShowWine={setShowWine}
                        allowFavorite={allowFavorite} />
                }
                {storedWine
                    && <WineCarousel
                        allWine={storedWine}
                        showWine={showWine}
                        setShowRecipe={setShowRecipe}
                        allowFavorite={allowFavorite} />
                }
            </section>
            { showGuide && <Guide /> }
        </>
    )
}

export default Home